import { useEffect, useRef } from "react";

/**
 * Marca o desmarca de golpe un grupo de destinatarios.
 *
 * Una gestoría puede tener quince personas autorizadas, y marcarlas de una en
 * una es el trabajo que este control ahorra. Muestra el avance («3/16») y queda
 * en estado intermedio cuando la selección es parcial.
 *
 * Se oculta solo si el grupo tiene una sola opción: ahí no ahorra nada.
 */
export function SeleccionarTodosCheckbox({
  ids,
  seleccionados,
  onToggleTodos,
  className = "",
}: {
  /** Ids del grupo que este control gobierna. */
  ids: string[];
  /** Ids marcados actualmente (de todos los grupos; se intersecta con `ids`). */
  seleccionados: Set<string> | string[];
  onToggleTodos: (ids: string[], marcar: boolean) => void;
  className?: string;
}) {
  const marcados = seleccionados instanceof Set
    ? ids.filter((id) => seleccionados.has(id))
    : ids.filter((id) => seleccionados.includes(id));
  const todos = ids.length > 0 && marcados.length === ids.length;
  const parcial = marcados.length > 0 && !todos;
  const ref = useRef<HTMLInputElement>(null);

  // El estado intermedio no es un valor del checkbox: hay que ponerlo a mano.
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = parcial;
  }, [parcial]);

  if (ids.length <= 1) return null;

  return (
    <label
      className={`flex cursor-pointer items-center gap-1.5 text-[10px] font-medium text-primary-strong ${className}`}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={todos}
        onChange={() => onToggleTodos(ids, !todos)}
        className="h-3.5 w-3.5 cursor-pointer"
      />
      Seleccionar todos ({marcados.length}/{ids.length})
    </label>
  );
}
